export enum LandingWineType {
	Undefined = 0,
	NonEp = 1,
	Ep = 2,
}
